import React, { useContext } from "react";
import { shippingFieldsArray } from "./fields";
import { PartnerContext } from "../context";
import { FieldsReducer } from "./../../../../CommonComponents/Reducer/Index";
import Card from "src/CommonComponents/Card";
export default function ShippingTab() {
  const { _partnerData, onChange, operation, dropDowns } =
    useContext(PartnerContext);

  const mergedFieldData = (field) => {
    let newFieldObject = {
      ...field,
      dataSource: _partnerData,
      onChange,
      disabled: field.displayOnly,
    };

    switch (operation) {
      case "Display":
        newFieldObject.disabled = true;
        break;
      case "Change":
        newFieldObject.disabled =
          newFieldObject.key || newFieldObject.displayOnly;
        break;
      case "Create":
        if (newFieldObject.displayOnly) {
          newFieldObject.disabled = true;
        }
        break;
      default:
    }

    return newFieldObject;
  };
  const fieldsState = {
    dataSource: _partnerData,
    onChange,
    dropDowns,
  };

  const fieldsToRender = shippingFieldsArray(fieldsState);
  return (
    <div className="row">
      <Card
        cardHeaderProps={{
          headerLabel: "Shipping",
        }}
        cardBody={fieldsToRender?.map((field, index) => (
          <FieldsReducer field={mergedFieldData(field)} key={index} />
        ))}
        style={{ width: "25rem" }}
      />
    </div>
  );
}
